import React from 'react';
import { CodeBlock } from '../cookbook-ui/custom-components/CodeBlock/CodeBlock';

interface Props {
  children?: React.ReactNode;
}
interface State {
  error?: Error;
}

export class ErrorBoundary extends React.PureComponent<Props, State> implements React.ComponentLifecycle<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error: Error): State {
    // This method supposed to be side-effect free, but `componentDidCatch` isn't always triggering, so log here too.
    console.error('ErrorBoundary caught an error:', error);
    return { error };
  }

  static componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error({ error, errorInfo });
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }
    const message = (
      <>
        <div>Something went wrong 😢. Please report this to the Kitchen team.</div>
        <br />
        <CodeBlock hasPadding={false} hasBorder={false} monospace={true} code={this.state.error.stack} />
      </>
    );
    return (
      <>
        <div style={{ padding: 24 }}>{message}</div>
      </>
    );
  }
}
